<template>
    <div id="wdr-component"></div>
</template>

<script>
import WebDataRocks from "@webdatarocks/webdatarocks";

export default {
    props: {
        afterchartdraw: Function,
        aftergriddraw: Function,
        beforegriddraw: Function,
        beforetoolbarcreated: Function,
        cellclick: Function,
        celldoubleclick: Function,
        componentFolder: String,
        customizeCell: Function,
        customizeContextMenu: Function,
        datachanged: Function,
        dataerror: Function,
        datafilecancelled: Function,
        dataloaded: Function,
        fieldslistclose: Function,
        fieldslistopen: Function,
        filterclose: Function,
        filteropen: Function,
        fullscreen: Function,
        global: Object,
        height: [String, Number],
        loadingdata: Function,
        loadinglocalization: Function,
        loadingolapstructure: Function,
        loadingreportfile: Function,
        localizationerror: Function,
        localizationloaded: Function,
        olapstructureerror: Function,
        olapstructureloaded: Function,
        openingreportfile: Function,
        querycomplete: Function,
        queryerror: Function,
        ready: Function,
        report: [String, Object],
        reportchange: Function,
        reportcomplete: Function,
        reportfilecancelled: Function,
        reportfileerror: Function,
        reportfileloaded: Function,
        runningquery: Function,
        toolbar: Boolean,
        update: Function,
        width: [Number, String],
    },
    mounted() {
        this.webdatarocks = new WebDataRocks({
            ...this.$props,
            beforetoolbarcreated() {},
            container: this.$el,
        })
    },
    beforeUpdate() {
        return false
    },
    methods: {
        customizeToolbar() {
            // console.log('customizeToolbar')
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import  '../../../../../node_modules/@webdatarocks/webdatarocks/webdatarocks.min.css';
</style>
